// If element is in viewport
function isInViewport(el) {
    var elementTop = el.offset().top;
    var elementBottom = elementTop + el.outerHeight();
    var viewportTop = jQuery(window).scrollTop();
    var viewportBottom = viewportTop + jQuery(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

jQuery( document ).ready(function() {

    // CircleType
    jQuery(".circle-numbers-item .border-text").each(function() {
        var circleType = new CircleType(jQuery(this)[0]);
        circleType.radius(155);
        // Border text offset
        if( jQuery(this).data('border-text-offset') ) {
            jQuery(this).css({ 'transform' : 'rotate('+jQuery(this).data('border-text-offset')+'deg)' });
        }
    });
    jQuery(".circle-numbers-item-container").each(function() {
        jQuery(this).addClass('scale-ready');
    });

});

jQuery(window).on('resize scroll', function() {
    
    // Odometer
    jQuery(".odo").each(function() {
        if(isInViewport(jQuery(this))) {
            var odometer = new Odometer({
                el: jQuery(this)[0]
            });
            odometer.update(jQuery(this).data('final-number'));
        }
    });

});